var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBidIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Star_Filled_Copy",
    "data-name": "icons/Star/Filled Copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.666,
    height: 12,
    viewBox: "0 0 14.666 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M11.333,6.667A.667.667,0,1,1,12,6,.667.667,0,0,1,11.333,6.667ZM6,6.667A.667.667,0,1,1,6.667,6,.667.667,0,0,1,6,6.667Zm-5.333,0A.667.667,0,1,1,1.333,6,.667.667,0,0,1,.667,6.667ZM11.333,4A.667.667,0,1,1,12,3.334.667.667,0,0,1,11.333,4ZM6,4a.667.667,0,1,1,.667-.667A.667.667,0,0,1,6,4Zm5.333-2.667A.667.667,0,1,1,12,.667.667.667,0,0,1,11.333,1.333Z",
    transform: "translate(1.333 5.333)",
    fill: "#fcfcfd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M2,9.334a2,2,0,1,1,2-2A2,2,0,0,1,2,9.334ZM2,6.667a.667.667,0,1,0,.667.667A.667.667,0,0,0,2,6.667Zm5.333,0a2,2,0,1,1,2-2A2,2,0,0,1,7.333,6.667ZM7.333,4A.667.667,0,1,0,8,4.667.667.667,0,0,0,7.333,4Zm5.333,0a2,2,0,1,1,2-2A2,2,0,0,1,12.667,4Zm0-2.667A.667.667,0,1,0,13.333,2,.667.667,0,0,0,12.667,1.333Z",
    fill: "#fcfcfd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidIcon);
export default __webpack_public_path__ + "static/media/bidIcon.a9524e075775024f8f407fc0ad8198b6.svg";
export { ForwardRef as ReactComponent };